import React, {Component} from 'react';
import {message} from "../../../../utils/message";
import {uuid} from "../../../../utils";
import {Modal} from "antd";
import PropTypes from 'prop-types';
import TransferPersonSelect from "../TransferPersonSelect";
import BaseComponent from "../../../../base/BaseComponent";

/**
 * creat by xcc
 * @description 卡片形式
 */
export default class TransferPosition extends BaseComponent {
    static propTypes = {
        styleOut: PropTypes.object,
    };
    static defaultProps = {
        styleOut: {},
    };

    constructor(props) {
        super(props);
        this.state = {
            positionItem: {},
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    // 转交
    transferPosition = (item) => {
        this.state.positionItem = item;
        this.transferPersonSelect.openModal();
    }

    okTransfer(checkedItem, callBack) {
        let that = this;
        Modal.confirm({
            title: '请注意，转交操作不可逆',
            content: "",
            okText: '继续',
            cancelText: '取消',
            onOk() {
                that.transferOk(checkedItem, callBack)
            },
            onCancel() {
            },
        })
    }

    transferOk(checkedItem, callBack) {
        const {refreshList} = this.props;
        let deptId = checkedItem?.deptList?.[0]?.id ||  checkedItem?.deptList?.[0]?._id || "";
        let body = {
            codes: [this.state.positionItem.code],
            receiverAccount: checkedItem._id,
            receiverDeptId: deptId,
        }
        this.request({
            url: "/cm-sites-media-consumer/position/handler/transferPositions",
            body: body,
            method: "post",
            callBack: (data) => {
                if (data) {
                    message.success("转交成功");
                    callBack();
                    refreshList();
                }
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    transferPersonSelectKey = uuid();

    render() {
        const {item, styleOut = {}} = this.props;
        //转交阵地按钮权限
        let transferLimit = this.permissionCheck("pms:positionManage:transferPosition");
        let transferPositionAdmin = this.permissionCheck("pms:positionManage:transferPositionAdmin");
        let transferShowByStatus = this.sysConfigGetValueByKey("positionManage.transfer.status", "审核通过,草稿");
        let isShowByStatusName = item.statusName && transferShowByStatus.indexOf(item.statusName) > -1;
        const isCurrentUser = window.currentUser.id === item.belongUserAccount;
        let isShowBtn =  ((transferLimit && isCurrentUser)||transferPositionAdmin) && isShowByStatusName; 
        return isShowBtn ? (
            <>
                <span style={{cursor: "pointer", ...styleOut}} onClick={() => this.transferPosition(item)}>转交账号</span>
                <TransferPersonSelect
                    title={"选择被转交人"}
                    key={this.transferPersonSelectKey}
                    ref={ref => this.transferPersonSelect = ref}
                    onCancel={() => {
                        this.transferPersonSelectKey = uuid();
                        this.setState({})
                    }}
                    onOkCall={(checkedItem, callBack) => {
                        this.transferPersonSelectKey = uuid();
                        this.okTransfer(checkedItem, callBack);
                    }}
                />
            </>
        ) : null
    }

}